const numberFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

export const getDecimalFormatter = (): Intl.NumberFormat => {
  return numberFormatter;
};
